import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import CategoryStrip from "@/components/CategoryStrip";
import CategoryShowcase from "@/components/CategoryShowcase";
import Ticker from "@/components/Ticker";
import RatesSection from "@/components/RatesSection";
import ChartsSection from "@/components/ChartsSection";
import MetalsSection from "@/components/MetalsSection";
import ProductsSection from "@/components/ProductsSection";
import AboutSection from "@/components/AboutSection";
import ReviewsSection from "@/components/ReviewsSection";
import SubscribeStrip from "@/components/SubscribeStrip";
import LocationSection from "@/components/LocationSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import AdminPage from "@/pages/AdminPage";
import { Toaster } from "@/components/ui/sonner";
import { useRates } from "@/hooks/useRates";
import { LanguageProvider } from "@/i18n";

function HomePage() {
  const { rates, updatedAt, usdinr, source } = useRates();

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.4,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 0.9,
      touchMultiplier: 1.6,
    });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App min-h-screen bg-[#0A0A0A]" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <CategoryShowcase />
        <CategoryStrip />
        <Ticker rates={rates} usdinr={usdinr} />
        <RatesSection rates={rates} updatedAt={updatedAt} usdinr={usdinr} source={source} />
        <SubscribeStrip />
        <ProductsSection />
        <ChartsSection />
        <MetalsSection rates={rates} />
        <AboutSection />
        <ReviewsSection />
        <LocationSection />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
        <Toaster position="top-center" theme="dark" />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
